import { EntryCollection } from "contentful";
import {
  ExpertSupport,
  ExpertSupportButtonType,
  ExpertSupportContentContainer,
} from "../models";
import { UserContextValues } from "../types";
import {
  convertToHtmlString,
  convertToPlainTextString,
  parseIntoImage,
} from "../utils";

export const createExpertSupport = (
  entry: EntryCollection<ExpertSupportContentContainer> | undefined,
  userContextValues?: UserContextValues,
): ExpertSupport | undefined => {

  if (!entry) {
    console.error("no entry found for expert support");
    return undefined;
  }

  const content = entry.items.at(0)?.fields;

  return {
    title: content?.title || "",
    primaryButtonText: content?.primaryButtonText,
    primaryButtonType: content?.primaryButtonType as ExpertSupportButtonType,
    secondaryButtonText: content?.secondaryButtonText,
    secondaryButtonType:
      content?.secondaryButtonType as ExpertSupportButtonType,
    subtext: convertToHtmlString(content?.subtext, userContextValues),
    supportNumber: convertToPlainTextString(
      convertToHtmlString(content?.supportNumber, userContextValues),
    ),
    image: parseIntoImage(content?.image),
    lottie: content?.lottie,
  };
};
